import { render, staticRenderFns } from "./SpeakerQuietIcon.vue?vue&type=template&id=252eb0cf&"
import script from "./SpeakerQuietIcon.vue?vue&type=script&lang=js&"
export * from "./SpeakerQuietIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports